/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as toast from '../_store/slice/toast';

export function AsideSupport() {
  const [professor, setProfessor] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      window.localStorage.getItem('part') === 'admin' ||
      window.localStorage.getItem('part') === 'professor'
    ) {
      setProfessor(true);
    }
  }, []);

  return (
    <aside>
      <h3>고객센터</h3>
      <Link to="/board/notice">공지사항</Link>
      <Link to="/board/errata">정오표</Link>
      <Link to="/board/lib">자료실</Link>
      {/* {window.localStorage.getItem('token') !== null ? (
        <Link to="/board/qna">질의응답</Link>
      ) : (
        <Link
          to="/login"
          onClick={() => {
            dispatch(toast.error({ message: '로그인이 필요합니다.' }));
          }}
        >
          질의응답
        </Link>
      )} */}
      <Link to="/board/books-all">도서목록 전체보기</Link>
      <div>
        <h4>정보안내</h4>
        <Link to="/info/bookstore">서점 안내</Link>
        <Link to="/info/cooperative">협력사 안내</Link>
        <Link to="/info/academy">교육기관 안내</Link>
        <Link to="/info/returns">반품/교환 안내</Link>
      </div>
      <div>
        <h4>요청하기</h4>
        {window.localStorage.getItem('token') !== null ? (
          <Link to="/board/publicationqna">출판문의 (저작자 전용)</Link>
        ) : (
          <Link
            className="link-to-publishaa"
            to="/login"
            onClick={() => {
              dispatch(toast.error({ message: '로그인이 필요합니다.' }));
            }}
          >
            출판문의 (저작자 전용)
          </Link>
        )}
        <Link
          className="link-to-group-buyingaa"
          to="#"
          onClick={() => {
            dispatch(
              toast.info({
                message: '공동구매를 원하시는 고객님은 당사 02)701-7421로 연락바랍니다.',
              })
            );
          }}
        >
          공동구매
        </Link>
      </div>
    </aside>
  );
}
